(() => {
  const root = (window.Shopify?.routes?.root || '/');
  document.addEventListener('click', event => {
    const choice = event.target.closest('[data-home-variant]');
    if (!choice) return;
    const actions = choice.closest('[data-home-actions]');
    const id = actions.querySelector('input[name="id"]');
    if (id) id.value = choice.dataset.homeVariant;
    actions.querySelector('[data-size-label]').textContent = choice.dataset.label;
    actions.closest('.odict-card').querySelector('.odict-card__title > span').textContent = choice.dataset.price;
    choice.closest('.odict-size-menu').open = false;
  });
  function updateGiftBox(form) {
    const page = form.closest('.odict-gift-page');
    const box = page?.querySelector('[data-gift-box-items]');
    if (!box) return;
    const selected = [...form.querySelectorAll('[name="gift-product"]:checked')];
    box.replaceChildren();
    selected.forEach(input => {
      const choice = input.closest('.odict-gift-choice');
      const tile = document.createElement('div'); tile.className = 'odict-gift-box__item';
      const img = choice.querySelector('img').cloneNode(true); img.loading = 'eager';
      const label = document.createElement('span');
      const variant = choice.querySelector('select[data-gift-variant]');
      label.textContent = choice.querySelector('label > span').textContent + (variant ? ' · ' + variant.selectedOptions[0].textContent : '') + ' × ' + choice.querySelector('[data-gift-quantity]').value;
      tile.append(img, label); box.append(tile);
    });
    page.querySelector('[data-gift-empty]').hidden = selected.length > 0;
    const status = page.querySelector('[data-gift-box-status]');
    status.textContent = selected.length ? status.dataset.filled : status.dataset.empty;
  }
  document.addEventListener('click', event => {
    const step = event.target.closest('[data-gift-step]'); if (!step) return;
    const choice = step.closest('.odict-gift-choice');
    const quantity = choice.querySelector('[data-gift-quantity]');
    quantity.value = Math.max(1, Math.min(99, (Number(quantity.value) || 1) + Number(step.dataset.giftStep)));
    choice.querySelector('[name="gift-product"]').checked = true;
    updateGiftBox(step.closest('form'));
  });
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-odict-gift]'); if (!form) return;
    const choice = event.target.closest('.odict-gift-choice');
    if (event.target.matches('select[data-gift-variant]')) choice.querySelector('[data-gift-price]').textContent = event.target.selectedOptions[0].dataset.price;
    if (event.target.matches('[data-gift-quantity]')) {
      event.target.value = Math.max(1, Math.min(99, Math.floor(Number(event.target.value) || 1)));
      choice.querySelector('[name="gift-product"]').checked = true;
    }
    updateGiftBox(form);
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-odict-gift]')) return;
    event.preventDefault();
    const status = form.querySelector('[data-gift-status]');
    const selected = [...form.querySelectorAll('[name="gift-product"]:checked')];
    if (!selected.length) { status.textContent = form.dataset.chooseError; form.querySelector('details').open = true; return; }
    const giftId = crypto.randomUUID();
    const properties = {_odict_gift_id: giftId, 'Gift box': giftId.slice(0, 8)};
    for (const [field, key] of [['gift-message','Gift message'],['gift-name','Recipient name'],['gift-phone','Recipient phone']]) {
      const value = form.elements[field].value.trim(); if (value) properties[key] = value;
    }
    const items = selected.map(input => ({id: input.closest('.odict-gift-choice').querySelector('[data-gift-variant]').value, quantity: Number(input.closest('.odict-gift-choice').querySelector('[data-gift-quantity]').value), properties}));
    const button = form.querySelector('[type="submit"]'); button.disabled = true; status.textContent = '';
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || form.dataset.error);
      window.location.assign(root + 'cart');
    } catch (error) { status.textContent = error.message || form.dataset.error; button.disabled = false; }
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-remove-gift]'); if (!button) return;
    button.disabled = true;
    const panel = button.closest('.odict-cart-gift');
    try {
      const updates = Object.fromEntries(JSON.parse(button.dataset.removeGift).map(key => [key, 0]));
      const response = await fetch(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({updates})});
      if (!response.ok) throw new Error(panel.dataset.error);
      window.location.reload();
    } catch (error) { panel.querySelector('[data-gift-remove-status]').textContent = panel.dataset.error; button.disabled = false; }
  });
  const safeGet = (storage, key, fallback) => { try { return JSON.parse(storage.getItem(key)) || fallback; } catch { return fallback; } };
  const safeSet = (storage, key, value) => { try { storage.setItem(key, JSON.stringify(value)); } catch {} };
  const emailKey = async email => {
    const buffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(email.trim().toLowerCase()));
    return [...new Uint8Array(buffer)].map(byte => byte.toString(16).padStart(2,'0')).join('');
  };
  function initNotify() {
    document.querySelectorAll('[data-odict-notify]').forEach(panel => {
      if (panel.dataset.bound) return; panel.dataset.bound = 'true';
      const form = panel.closest('form');
      const pending = safeGet(sessionStorage, 'odict-notify-pending', null);
      if (panel.dataset.success === 'true' && pending?.variant === panel.dataset.variant) {
        const records = safeGet(localStorage, 'odict-notify-confirmed', {});
        records[pending.key] = true; safeSet(localStorage, 'odict-notify-confirmed', records);
        panel.closest('details').open = true;
        panel.querySelector('button').textContent = panel.dataset.sent;
        panel.querySelector('button').disabled = true;
        panel.querySelector('[data-notify-status]').textContent = panel.dataset.sent;
        safeSet(sessionStorage, 'odict-notify-pending', null);
      }
      form.addEventListener('submit', async event => {
        if (form.dataset.validated === 'true') return;
        event.preventDefault();
        if (!form.reportValidity()) return;
        const key = panel.dataset.variant + ':' + await emailKey(form.elements['contact[email]'].value);
        if (safeGet(localStorage, 'odict-notify-confirmed', {})[key]) {
          panel.querySelector('[data-notify-status]').textContent = panel.dataset.duplicate;
          return;
        }
        safeSet(sessionStorage, 'odict-notify-pending', {variant:panel.dataset.variant,key});
        form.dataset.validated = 'true';
        form.requestSubmit();
      });
    });
  }
  initNotify();
  new MutationObserver(initNotify).observe(document.querySelector('main') || document.body, {childList:true,subtree:true});
})();
